export default "__VITE_ASSET__15d4d5b3__"